<rt-admins-avatars
  [admins]="admins"
  [limit]="3"
  [direction]="'vertical'"
  [tooltipPosition]="'left'"
  [tooltipMaxWidth]="270"
  [tooltipWordWrap]="true"
  [spacing]="'small'"
  [renderAdminTooltip]="renderAdminTooltip"
  [renderOtherAdminsTooltip]="renderOtherAdminsTooltip"
  [moreButtonAsCounter]="true"
  variant="default"
></rt-admins-avatars>
